<template>
  <div class="animated fadeIn">
    <Row>
      <Form ref="loginForm" label-width="150">
        <FormItem label="默认母种单价(元)">
          <InputNumber style="display: inline-block; width: 250px;" v-model="defaultMotherPrice"
                       placeholder="默认母种单价">
          </InputNumber>
        </FormItem>
        <FormItem label="默认育苗率">
          <InputNumber style="display: inline-block; width: 250px;" v-model="defaultGestationRate"
                       placeholder="默认育苗率">
          </InputNumber>
        </FormItem>
        <FormItem label="默认幼苗单价(元)">
          <InputNumber style="display: inline-block; width: 250px;" v-model="defaultChildrenPrice"
                       placeholder="默认幼苗单价">
          </InputNumber>
        </FormItem>
        <FormItem label="默认管理费率">
          <InputNumber style="display: inline-block; width: 250px;" v-model="defaultManageRate"
                       placeholder="默认管理费率">
          </InputNumber>
        </FormItem>
        <FormItem label="默认母种回收单价(元)">
          <InputNumber style="display: inline-block; width: 250px;" v-model="defaultMotherBuybackPrice"
                       placeholder="默认母种回收单价">
          </InputNumber>
        </FormItem>
        <FormItem label="默认母种存活率">
          <InputNumber style="display: inline-block; width: 250px;" v-model="defaultMotherSurvivalRate"
                       placeholder="默认母种存活率">
          </InputNumber>
        </FormItem>
        <FormItem label="首次购买数量">
          <InputNumber style="display: inline-block; width: 250px;" v-model="firstBuyCount"
                       placeholder="首次购买数量">
          </InputNumber>
        </FormItem>
        <FormItem label="计算周期数">
          <InputNumber style="display: inline-block; width: 250px;" v-model="periodCount"
                       placeholder="计算周期数">
          </InputNumber>
        </FormItem>
      </Form>
    </Row>
    <Row>
      <Button @click="calculate">计算</Button>
    </Row>
    <Row style="margin-top: 10px;">
      <div>
        <div style="position:relative;">
          <Table height="600" :columns="columns" :stripe="true" :data="periodDatas" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
      </div>
    </Row>
  </div>
</template>

<script>

import Vue from 'vue'
import store from '@/store'
import {mapActions} from 'vuex'

export default {
  name: 'leechcalculator',
  data() {
    return {
      defaultMotherPrice: 3,
      defaultGestationRate: 10,
      defaultChildrenPrice: 0.8,
      defaultManageRate: 0.3,
      defaultMotherBuybackPrice: 2.2,
      defaultMotherSurvivalRate: 0.8,
      firstBuyCount: 10000,
      periodCount: 3,

      listLoadding: false,

      periodDatas: [],

      columns: [
        {
          title: '周期',
          key: 'period',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '购买量',
          key: 'buyCount',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '购买母种总价',
          key: 'buyMotherTotal',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '育苗率',
          key: 'gestationRate',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '育苗总数',
          key: 'childrenCount',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '幼苗总价',
          key: 'childrenTotal',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '毛利',
          key: 'grossProfit',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '管理费率',
          key: 'manageRate',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '管理费',
          key: 'manageExpenses',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '售苗利润',
          key: 'sellGrossProfit',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '母种存活率',
          key: 'motherSurvivalRate',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '母种存量',
          key: 'motherSurvival',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '母种回收单价',
          key: 'motherBuybackPrice',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '母种回收总价',
          key: 'motherBuybackTotal',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '总支出',
          key: 'expenditure',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '总收入',
          key: 'income',
          ellipsis: 'true',
          minWidth: 80
        },
        {
          title: '周期回报率(不含母种)',
          key: 'roi',
          ellipsis: 'true',
          minWidth: 80,
          render: (h, params) => {
            return h('label', (params.row.roi * 100).toFixed(2) + '%')
          }
        },
      ]
    }
  },
  computed: {},
  methods: {
    ...mapActions([]),
    exportData() {
      this.$refs.table.exportCsv({
        filename: '错误日志.csv'
      })
    },
    addUserModal() {

    },
    calculate() {

      this.periodDatas = []

      let lastDataItem = null;

      for (let i = 1; i <= this.periodCount; i++) {
        let dataItem = {
          period: i,
          buyCount: null,
          buyMotherTotal: null,
          gestationRate: null,
          childrenCount: null,
          childrenTotal: null,
          grossProfit: null,
          manageRate: null,
          manageExpenses: null,
          sellGrossProfit: null,
          motherSurvivalRate: null,
          motherSurvival: null,
          motherBuybackPrice: null,
          motherBuybackTotal: null,
          expenditure: null,
          income: null,
          roi: null,
        }
        if (i == 1) {
          dataItem.period = 1
          dataItem.buyCount = this.firstBuyCount
          dataItem.buyMotherTotal = dataItem.buyCount * this.defaultMotherPrice
          dataItem.gestationRate = this.defaultGestationRate
          dataItem.childrenCount = Math.floor(this.firstBuyCount * dataItem.gestationRate)
          dataItem.childrenTotal = dataItem.childrenCount * this.defaultChildrenPrice
          dataItem.grossProfit = dataItem.childrenTotal - dataItem.buyMotherTotal
          dataItem.manageRate = this.defaultManageRate
          dataItem.manageExpenses = Math.floor(dataItem.grossProfit * dataItem.manageRate * 100) / 100
          dataItem.sellGrossProfit = dataItem.grossProfit - dataItem.manageExpenses
          dataItem.motherSurvivalRate = this.defaultMotherSurvivalRate
          dataItem.motherSurvival = Math.floor(dataItem.motherSurvivalRate * dataItem.buyCount)
          dataItem.motherBuybackPrice = this.defaultMotherBuybackPrice
          dataItem.motherBuybackTotal = Math.floor(dataItem.motherSurvival * dataItem.motherBuybackPrice * 100) / 100
          dataItem.expenditure = dataItem.buyMotherTotal + dataItem.manageExpenses
          dataItem.income = dataItem.childrenTotal
          dataItem.roi = (dataItem.income - dataItem.expenditure) / dataItem.expenditure
        } else {
          dataItem.period = i
          dataItem.buyCount = 0
          dataItem.buyMotherTotal = dataItem.buyCount * this.defaultMotherPrice
          dataItem.gestationRate = this.defaultGestationRate
          dataItem.childrenCount = Math.floor(lastDataItem.motherSurvival * dataItem.gestationRate)
          dataItem.childrenTotal = dataItem.childrenCount * this.defaultChildrenPrice
          dataItem.grossProfit = dataItem.childrenTotal - dataItem.buyMotherTotal
          dataItem.manageRate = this.defaultManageRate
          dataItem.manageExpenses = Math.floor(dataItem.grossProfit * dataItem.manageRate * 100) / 100
          dataItem.sellGrossProfit = dataItem.grossProfit - dataItem.manageExpenses
          dataItem.motherSurvivalRate = this.defaultMotherSurvivalRate
          dataItem.motherSurvival = Math.floor(dataItem.motherSurvivalRate * lastDataItem.motherSurvival)
          dataItem.motherBuybackPrice = this.defaultMotherBuybackPrice
          dataItem.motherBuybackTotal = Math.floor(dataItem.motherSurvival * dataItem.motherBuybackPrice * 100) / 100
          dataItem.expenditure = dataItem.buyMotherTotal + dataItem.manageExpenses
          dataItem.income = dataItem.childrenTotal
          dataItem.roi = (dataItem.income - dataItem.expenditure) / dataItem.expenditure
        }

        lastDataItem = dataItem
        this.periodDatas.push(dataItem)
      }
    }
  },
  activated() {

  },
  mounted() {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>

</style>
